<template>
    <div class="footer-bottom">
        <div class="copyright">
            <div class="copyright-describe">
                <span>© 2025 KSCN 版权所有</span>
                <span>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                <img src="@/assets/images/footer/备案图标.png" alt="备案图标" />
                <span>&nbsp;</span>
                <a href="https://beian.mps.gov.cn/#/query/webSearch?code=50011902000523" rel="noreferrer" target="_blank">渝公网安备50011902000523</a>
                <span>&nbsp;&nbsp;</span>
                <a href="https://beian.miit.gov.cn/" target="_blank">渝ICP备2024044311号-1</a>
            </div>
            <div class="footer-icons">
                <a href="https://chatgpt.com/" target="_blank"><img src="@/assets/images/footer/ChatGPT.png" alt="ChatGPT" /></a>
                <a href="https://cn.ubuntu.com/" target="_blank"><img src="@/assets/images/footer/Ubuntu.png" alt="Ubuntu" /></a>
                <a href="https://www.deepseek.com/" target="_blank"><img src="@/assets/images/footer/DeepSeek.png" alt="DeepSeek" /></a>
                <a href="https://www.mysql.com/" target="_blank"><img src="@/assets/images/footer/MySQL.png" alt="MySQL" /></a>
                <a href="https://www.aliyun.com/" target="_blank"><img src="@/assets/images/footer/阿里云.png" alt="阿里云" /></a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Footer",
};
</script>

<style scoped>
@import "@/assets/styles/footer.css";
</style>
